import * as React from 'react';
import { TreeMenuController, TreeMenuControllerProps } from './TreeMenu.controller';
import { gql } from '@apollo/client';
import { useUpdateImportFolderMutation, useUpdateImportSourceMutation } from '../../../../models/graphql';
import { useCallback, useContext } from 'react';
import { TreeMenuContext } from './TreeMenuProvider';

gql`
  mutation UpdateImportFolder($importFolderId: ID!, $input: UpdateImportFolderInput!) {
    updateImportFolder(importFolderId: $importFolderId, input: $input) {
      ...CoreImportFolderFields
    }
  }

  mutation UpdateImportSource($importSourceId: ID!, $input: UpdateImportSourceInput!) {
    updateImportSource(importSourceId: $importSourceId, input: $input) {
      ...ImportSourceFields
    }
  }
`;

export type TreeMenuApolloProps = {
  // ...
};

export const TreeMenuApollo = (props: TreeMenuApolloProps): JSX.Element => {
  const [updateImportFolder] = useUpdateImportFolderMutation();
  const [updateImportSource] = useUpdateImportSourceMutation();

  const { reFetchTreeMenu } = useContext(TreeMenuContext);

  const updateFolderSortOrder = useCallback(
    async (folderId: string, order: number) => {
      updateImportFolder({
        variables: { importFolderId: folderId, input: { order: order } },
        update: () => reFetchTreeMenu()
      });
    },
    [reFetchTreeMenu, updateImportFolder]
  );

  const updateSourceSortOrder = useCallback(
    async (importSourceId: string, importFolderId: string | null, order: number) => {
      updateImportSource({
        variables: {
          importSourceId,
          input: {
            importFolderId: importFolderId,
            order
          }
        },
        update: () => reFetchTreeMenu()
      });
    },
    [reFetchTreeMenu, updateImportSource]
  );

  const controllerProps: TreeMenuControllerProps = {
    ...props,
    updateFolderSortOrder,
    updateSourceSortOrder,
    reFetch: reFetchTreeMenu
  };

  return <TreeMenuController {...controllerProps} />;
};
